export default "__VITE_ASSET__CuYgfyTK__"